import React from 'react'

const Footer = () => {
  return ( 
    <footer>
      <p>Crafted with ♥ in the EU by <a href="https://james.vodang.com" target="_blank">James Vodang</a></p>
    </footer>
   );
}
 
export default Footer;
